import apiClient from '../api/client';

export const submitRegistration = async (formData) => {
  const body = new FormData();
  Object.entries(formData).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      body.append(key, value);
    }
  });

  const { data } = await apiClient.post('/registration/submit', body, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data;
};

export const verifyPayment = async ({ razorpay_order_id, razorpay_payment_id, razorpay_signature }) => {
  const { data } = await apiClient.post('/registration/verify-payment', {
    razorpay_order_id,
    razorpay_payment_id,
    razorpay_signature
  });
  return data;
};

export const getRegistrationStatus = async (orderId) => {
  const { data } = await apiClient.get(`/registration/status/${orderId}`);
  return data;
};
